import { render } from "./UserItem.vue?vue&type=template&id=57e49ab8&scoped=true"
import script from "./UserItem.vue?vue&type=script&lang=js"
export * from "./UserItem.vue?vue&type=script&lang=js"

import "./UserItem.vue?vue&type=style&index=0&id=57e49ab8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e49ab8"]])

export default __exports__